<template>
  <b-list-group-item>
    <div class="font-weight-bold text-primary">
      Makbuz
    </div>
    <div>
      <div v-if="dataModal.dataItem.receipt_no">
        No: {{ dataModal.dataItem.receipt_no }}
      </div>
      <b-badge :variant="dataModal.dataItem.is_receipt === '1'? 'light-success' : 'light-danger'">
        {{ dataModal.dataItem.is_receipt === '1'? 'Makbuz Kesildi' : 'Makbuz Kesilmedi' }}
      </b-badge>
    </div>
  </b-list-group-item>
</template>
<script>
import { BBadge, BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'DonateDate',
  components: {
    BBadge,
    BListGroupItem,
  },
  computed: {
    dataModal() {
      return this.$store.getters['accountActivities/transferModal']
    },
  },
}
</script>
